import { FreshnessBadge } from '@/components/FreshnessBadge';
import { freshnessSourceLabel, type FreshnessRecord } from '@/lib/freshness';

/**
 * The per-source freshness row for the cash-flow toolbar (replit.md §0.7). One
 * badge per sync source with its relative age, driven entirely by the shared
 * freshness layer — NOT a single global badge, and never its own staleness math.
 */
export interface SourceFreshnessProps {
  records: FreshnessRecord[];
}

export function SourceFreshness({ records }: SourceFreshnessProps) {
  if (records.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-2" aria-label="Allikate värskus">
      {records.map((record) => (
        <FreshnessBadge key={record.entity} status={record.freshness} label={freshnessSourceLabel(record)} />
      ))}
    </div>
  );
}
